export default "__VITE_ASSET__d9GIN9cs__"